/* eslint-disable check-file/filename-blocklist */
export const LEARN_MORE_LINK =
	'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';

export enum SECTION_MESSAGE_APPEARANCE_TYPES {
	DEFAULT = 'default',
	FLAT = 'flat',
	INLINE = 'inline',
	INLINE_MODAL = 'inline-modal',
}

export const UP_FLOW_EP_MESSAGE_ID = 'confluence-up-flow-modal';
